<div>
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center gap-3">
      <div class="w-9 h-9 rounded-full bg-rougeNovo flex items-center justify-center text-white font-bold text-sm">
        {{ language }}
      </div>
      <span class="text-white font-semibold text-lg">{{ languageLabel }}</span>
    </div>
    @if (isPrimary) {
      <span class="text-rougeNovo text-sm font-medium">
        {{ 'PACKAGES_PERSO_MANAGEMENT.LANGUE_PRINCIPALE' | translate }}
      </span>
    }
  </div>

  <div class="mb-4">
    <label [for]="'nom' + language" class="block text-white text-sm font-semibold mb-2">
      {{ 'PACKAGES_PERSO_MANAGEMENT.TITRE' | translate }}
    </label>
    <input [id]="'nom' + language" type="text" [(ngModel)]="nom" (ngModelChange)="nomChange.emit($event)"
      [name]="'nom' + language" maxlength="100" [placeholder]="titrePlaceholder"
      class="w-full p-2.5 rounded bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-rougeNovo" />
    </div>

    <div class="mb-4">
      <label [for]="'description' + language" class="block text-white text-sm font-semibold mb-2">
        {{ 'PACKAGES_PERSO_MANAGEMENT.DESCRIPTION' | translate }}
      </label>
      <textarea [id]="'description' + language" [(ngModel)]="description"
        (ngModelChange)="descriptionChange.emit($event)" [name]="'description' + language" rows="3"
        maxlength="250" [placeholder]="descriptionPlaceholder"
      class="w-full p-2.5 rounded bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-rougeNovo"></textarea>
    </div>

    @if (contentType === 'pdf' && showContentUpload) {
      <div class="mb-2">
        <label class="block text-white text-sm font-semibold mb-2">
          {{ 'PACKAGES_PERSO_MANAGEMENT.FICHIER_PDF' | translate }}
        </label>
        @if (!pdfFile && existingPdfFileName) {
          <div
            class="flex items-center justify-between p-3 bg-gray-800 border border-gray-700 rounded">
            <div class="flex items-center gap-2 min-w-0">
              <mat-icon class="material-symbols-outlined text-rougeNovo flex-shrink-0">picture_as_pdf</mat-icon>
              <span class="text-white text-sm truncate">{{ existingPdfFileName }}</span>
              <span class="text-gray-400 text-xs flex-shrink-0">{{ 'PACKAGES_PERSO_MANAGEMENT.EXISTING_FILE' | translate }}</span>
            </div>
            <button type="button" (click)="existingPdfRemoved.emit()"
              class="text-red-400 hover:text-red-300 flex-shrink-0 ml-2">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
        @if (!pdfFile && !existingPdfFileName) {
          <div (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            class="border-2 border-dashed rounded-lg p-8 flex flex-col items-center gap-3 transition-colors"
            [class.border-gray-700]="!isDragging" [class.border-rougeNovo]="isDragging">
            <div class="w-12 h-12 rounded-full bg-gray-800 border border-gray-700 flex items-center justify-center">
              <mat-icon class="material-symbols-outlined text-gray-400">upload</mat-icon>
            </div>
            <p class="text-gray-300 text-sm">{{ 'PACKAGES_PERSO_MANAGEMENT.CLIQUEZ_TELECHARGER' | translate }}</p>
            <p class="text-gray-500 text-xs">{{ 'PACKAGES_PERSO_MANAGEMENT.PDF_MAX_SIZE' | translate }}</p>
            <label [for]="'pdfFile' + language"
              class="cursor-pointer px-4 py-2 bg-gray-800 border border-gray-700 text-white text-sm rounded font-medium hover:bg-gray-700">
              {{ 'PACKAGES_PERSO_MANAGEMENT.CHOISIR_FICHIER' | translate }}
              <input [id]="'pdfFile' + language" type="file" accept=".pdf" class="sr-only"
                (change)="onFileSelected($event, 'pdf')" />
              </label>
            </div>
          }
          @if (pdfFile) {
            <div class="flex items-center justify-between p-3 bg-gray-800 border border-gray-700 rounded">
              <div class="flex items-center gap-2 min-w-0">
                <mat-icon class="material-symbols-outlined text-rougeNovo flex-shrink-0">picture_as_pdf</mat-icon>
                <span class="text-white text-sm truncate">{{ pdfFile.name }}</span>
              </div>
              <button type="button" (click)="removeFile('pdf')" class="text-red-400 hover:text-red-300 flex-shrink-0 ml-2">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
          @if (fileError) {
            <div class="mt-2 text-sm text-red-400">{{ fileError }}</div>
          }
        </div>
      }

      @if (contentType === 'video' && showContentUpload) {
        <div class="mb-4">
          <label class="block text-white text-sm font-semibold mb-2">
            {{ 'PACKAGES_PERSO_MANAGEMENT.FICHIER_VIDEO' | translate }}
          </label>
          <div class="flex gap-2 mb-3">
            <button type="button" (click)="videoMode = 'file'"
              [class]="videoMode === 'file' ? 'bg-rougeNovo text-white' : 'bg-gray-800 text-white border border-gray-700 hover:bg-gray-700'"
              class="px-4 py-2 rounded font-medium text-sm transition-colors">
              {{ 'PACKAGES_PERSO_MANAGEMENT.FICHIER_VIDEO' | translate }}
            </button>
            <button type="button" (click)="videoMode = 'vimeo'"
              [class]="videoMode === 'vimeo' ? 'bg-rougeNovo text-white' : 'bg-gray-800 text-white border border-gray-700 hover:bg-gray-700'"
              class="px-4 py-2 rounded font-medium text-sm transition-colors">
              Vimeo ID
            </button>
          </div>
          @if (videoMode === 'file' && !videoFile) {
            <div
              class="border-2 border-dashed border-gray-700 rounded-lg p-8 flex flex-col items-center gap-3">
              <div class="w-12 h-12 rounded-full bg-gray-800 border border-gray-700 flex items-center justify-center">
                <mat-icon class="material-symbols-outlined text-gray-400">upload</mat-icon>
              </div>
              <p class="text-gray-300 text-sm">{{ 'PACKAGES_PERSO_MANAGEMENT.CLIQUEZ_TELECHARGER' | translate }}</p>
              <p class="text-gray-500 text-xs">{{ 'PACKAGES_PERSO_MANAGEMENT.VIDEO_MAX_SIZE' | translate }}</p>
              <label [for]="'videoFile' + language"
                class="cursor-pointer px-4 py-2 bg-gray-800 border border-gray-700 text-white text-sm rounded font-medium hover:bg-gray-700">
                {{ 'PACKAGES_PERSO_MANAGEMENT.CHOISIR_FICHIER' | translate }}
                <input [id]="'videoFile' + language" type="file" accept="video/*" class="sr-only"
                  (change)="onFileSelected($event, 'video')" />
                </label>
              </div>
            }
            @if (videoMode === 'file' && videoFile) {
              <div
                class="p-3 bg-gray-800 border border-gray-700 rounded">
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-2 min-w-0">
                    <mat-icon class="material-symbols-outlined text-rougeNovo flex-shrink-0">videocam</mat-icon>
                    <span class="text-white text-sm truncate">{{ videoFile.name }}</span>
                  </div>
                  <button type="button" (click)="removeFile('video')" [disabled]="isVideoUploading"
                    class="text-red-400 hover:text-red-300 flex-shrink-0 ml-2 disabled:opacity-50 disabled:cursor-not-allowed">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                @if (isVideoUploading) {
                  <div class="mt-3">
                    <div class="h-2 w-full rounded-full bg-gray-700 overflow-hidden">
                      <div class="h-full bg-rougeNovo transition-all duration-200" [style.width.%]="videoUploadProgress"></div>
                    </div>
                    <p class="text-xs text-gray-400 mt-1">
                      {{ 'PACKAGES_PERSO_MANAGEMENT.VIDEO_UPLOADING' | translate }} {{ videoUploadProgress }}%
                    </p>
                  </div>
                }
              </div>
            }
            @if (videoMode === 'vimeo') {
              <input type="text" inputmode="numeric"
                [ngModel]="vimeoId" (ngModelChange)="onVimeoIdInput($event)"
                [name]="'vimeoId' + language"
                [placeholder]="'PACKAGES_PERSO_MANAGEMENT.EXAMPLE_VIMEO_ID' | translate"
                class="w-full p-2.5 rounded bg-gray-800 border text-white placeholder-gray-500 focus:outline-none focus:border-rougeNovo"
                [class.border-gray-700]="!vimeoIdError" [class.border-red-500]="!!vimeoIdError" />
            }
            @if (videoMode === 'vimeo' && vimeoIdError) {
              <div
                class="mt-2 p-2.5 rounded-lg bg-red-900/20 border border-red-900 text-red-300 text-sm flex items-start gap-2">
                <mat-icon class="material-symbols-outlined !text-[18px] !w-[18px] !h-[18px] !leading-[18px] flex-shrink-0 mt-0.5">error</mat-icon>
                <span>{{ vimeoIdError }}</span>
              </div>
            }
          </div>
        }

        @if (contentType === 'video' && showContentUpload) {
          <div class="mb-2">
            <label class="block text-white text-sm font-semibold mb-2">
              {{ 'PACKAGES_PERSO_MANAGEMENT.SOUS_TITRES_OPTIONNEL' | translate }}
            </label>
            <div class="flex items-center justify-between p-3 bg-gray-800 border border-gray-700 rounded">
              <div class="flex items-center gap-2 min-w-0">
                <mat-icon class="material-symbols-outlined text-gray-400 !text-[20px] !w-5 !h-5 !leading-5 flex-shrink-0">upload</mat-icon>
                <span class="text-gray-400 text-sm truncate">
                  {{ subtitleFile ? subtitleFile.name : ('PACKAGES_PERSO_MANAGEMENT.TELECHARGER_VTT' | translate) }}
                </span>
              </div>
              @if (!subtitleFile) {
                <label [for]="'subtitleFile' + language"
                  class="cursor-pointer text-rougeNovo text-sm font-medium hover:text-red-400 flex-shrink-0 ml-2">
                  {{ 'PACKAGES_PERSO_MANAGEMENT.PARCOURIR' | translate }}
                  <input [id]="'subtitleFile' + language" type="file" accept=".vtt,.srt" class="sr-only"
                    (change)="onFileSelected($event, 'subtitle')" />
                  </label>
                }
                @if (subtitleFile) {
                  <button type="button" (click)="removeFile('subtitle')"
                    class="text-red-400 hover:text-red-300 flex-shrink-0 ml-2">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </div>
              @if (isEditMode) {
                <p class="mt-2 text-xs text-gray-400">
                  {{ 'PACKAGES_PERSO_MANAGEMENT.SUBTITLES_KEPT_NOTE' | translate }}
                </p>
              }
            </div>
          }
        </div>
